<!-- 书写解答题 -->
<template>
  <div class="topic_choice">
    <div class="flex topic_select">
      <!-- <div class="topic_type">{{ questionTypeName }}</div> -->
      <div class="topic_content scroll_x mar_left_10 flex-1">
        <div class="topic_title" v-html="topicInfo?.questionTitle" v-mathml></div>
        <div class="flex Flexalign mt-15" v-if="getAudioUrl(topicInfo.otherRule)">
          <div class="mr-10">音频：</div>
          <audio :src="getAudioUrl(topicInfo.otherRule)" controls></audio>
        </div>
      </div>
    </div>
    <div class="mt-10">
      <div class="my-20">请完成下面的小题</div>
      <div v-for="(item, index) in topicInfo.questionContext?.subQuestions" :key="index">
        <!-- 单选 -->
        <choice v-if="item.type == 1" :questionInfo="item" @answerQuestion="answerQuestion" :disabled="testExamTime.remainingTime <= 0 || isShowScoring || topicInfo.showAnalysis
          " :subQuestionNum="index" :testType="testType" :isShowScoring="isShowScoring" :showAnswer="true"></choice>
        <!-- 多选 -->
        <multipleChoice v-else-if="item.type == 2" :questionInfo="JSON.stringify(item)" @answerQuestion="answerQuestion"
          :disabled="testExamTime.remainingTime <= 0 || isShowScoring || topicInfo.showAnalysis
            " :subQuestionNum="index" :testType="testType" :isShowScoring="isShowScoring" :showAnswer="true">
        </multipleChoice>
        <!-- 判断 -->
        <trueOrFalse v-else-if="item.type == 4" :questionInfo="item" @answerQuestion="answerQuestion" :disabled="testExamTime.remainingTime <= 0 || isShowScoring || topicInfo.showAnalysis
          " :subQuestionNum="index" :testType="testType" :isShowScoring="isShowScoring" :showAnswer="true">
        </trueOrFalse>
        <!-- 排序 -->
        <sortNew v-else-if="item.type == 6" :questionInfo="item" @answerQuestion="answerQuestion" :disabled="testExamTime.remainingTime <= 0 || isShowScoring || topicInfo.showAnalysis
          " :subQuestionNum="index" :testType="testType" :isShowScoring="isShowScoring" :showAnswer="true">
        </sortNew>
        <!-- 填空题 -->
        <fillIn v-else-if="item.type == 3" :questionInfo="item" @answerQuestion="answerQuestion" :disabled="testExamTime.remainingTime <= 0 || isShowScoring || topicInfo.showAnalysis
          " :subQuestionNum="index" :testType="testType" :isShowScoring="isShowScoring" :showAnswer="true">
        </fillIn>
        <!-- 书写解答题 -->
        <textAnswer v-else-if="item.type == 7" :questionInfo="item" @answerQuestion="answerQuestion" :disabled="testExamTime.remainingTime <= 0 || isShowScoring || topicInfo.showAnalysis
          " :subQuestionNum="index" :testType="testType" :isShowScoring="isShowScoring" :showAnswer="true">
        </textAnswer>
        <div v-else-if="
          item.type != 1 &&
          item.type != 2 &&
          item.type != 3 &&
          item.type != 4 &&
          item.type != 6 &&
          item.type != 7
        ">
          <moe-empty url="development_icon.png" emptyText="更多题型开发中"></moe-empty>
        </div>
      </div>
    </div>
    <div v-if="!testType">
      <div class="topic_answer mt-20" v-if="isShowScoring || topicInfo.showAnalysis">
        <!-- <div class="answer_top flex FlexBetween">
          <div class="">
            <div>正确答案：</div>
            <div class="flex FlexWrap" v-for="(item, index) in topicInfo.questionContext.subQuestions" :key="index">
              <div>{{ `第${index + 1}小题答案` }}：</div>
              <div v-html="$Tools.handlerImg(getAnswer(item, 'answer'))"></div>
            </div>
            <div class="ml-20">你的答案</div>
            <div class="flex FlexWrap" v-for="(item, index) in topicInfo.questionContext.subQuestions" :key="index">
              <div>{{ `第${index + 1}小题答案` }}：</div>
              <div v-html="$Tools.handlerImg(getAnswer(item, 'doAnswer'))"></div>
            </div>
          </div>
        </div> -->
        <div class="answer_top p-20 mt-20">
          <div class="question_analyze mar_top_10">【试题分析】</div>
          <div class="mar_top_10" v-html="$Tools.handlerImg(topicInfo.questionAnalyze)" v-mathml></div>
          <div class="question_analyze mar_top_10">【解析】</div>
          <div class="mar_top_10" v-html="$Tools.handlerImg(topicInfo.questionExplanation)" v-mathml></div>
        </div>
      </div>
    </div>
    <div v-if="testType == 1">
      <div class="topic_answer mt-20" v-if="isShowScoring || topicInfo.showAnalysis">
        <!-- <div class="answer_top flex FlexBetween" v-if="getIsShow(1)">
          <div class="">
            <div>正确答案：</div>
            <div class="flex FlexWrap" v-for="(item, index) in topicInfo.questionContext.subQuestions" :key="index">
              <div>{{ `第${index + 1}小题答案` }}：</div>
              <div v-html="$Tools.handlerImg(getAnswer(item, 'answer'))"></div>
            </div>
            <div class="ml-20">你的答案</div>
            <div class="flex FlexWrap" v-for="(item, index) in topicInfo.questionContext.subQuestions" :key="index">
              <div>{{ `第${index + 1}小题答案` }}：</div>
              <div v-html="$Tools.handlerImg(getAnswer(item, 'doAnswer'))"></div>
            </div>
          </div>
        </div> -->
        <div class="answer_top p-20 mt-20" v-if="getIsShow(2) || getIsShow(3) || showAnswer">
          <div class="question_analyze mar_top_10" v-if="getIsShow(2) || showAnswer">【试题分析】</div>
          <div class="mar_top_10" v-html="$Tools.handlerImg(topicInfo.questionAnalyze)" v-if="getIsShow(2) || showAnswer" v-mathml></div>
          <div class="question_analyze mar_top_10" v-if="getIsShow(3) || showAnswer">【解析】</div>
          <div class="mar_top_10" v-html="$Tools.handlerImg(topicInfo.questionExplanation)" v-if="getIsShow(3) || showAnswer" v-mathml></div>
        </div>
      </div>
    </div>
    <div class="marker_info" v-if="topicInfo.markerComment">
      <div class="marker_label mb-10">题目批语：</div>
      <div v-html="$Tools.handlerImg(topicInfo.markerComment)" v-mathml></div>
    </div>
  </div>
</template>

<script>
import choice from "./subQuetion/choice.vue";
import multipleChoice from "./subQuetion/multipleChoice.vue";
import fillIn from "./subQuetion/fillIn.vue";
import sortNew from "./subQuetion/sortNew.vue";
import trueOrFalse from "./subQuetion/trueOrFalse.vue";
import textAnswer from "./subQuetion/textAnswer.vue";
import { mapState } from "vuex";
export default {
  name: "GjkcH5Choice",
  props: {
    questionInfo: {},
    isShowScoring: {
      default: false,
    },
    questionTypeName: {
      default: "判断题",
    },
    testType: {}, // 区分闯关，为1时是闯关
    //  用于错题展示隐藏用户答案信息等
    hideUserAnswer: {
      default: false,
    },
    isChallenge: {},
    showAnswer:{}, // 用于测评报告弹题展示解析等
  },
  components: { choice, multipleChoice, fillIn, sortNew, trueOrFalse, textAnswer },
  computed: {
    ...mapState({
      testExamTime: (state) => state.exam.testExamTime,
      testExamInfo: (state) => state.exam.testExamInfo,
    }),
  },

  data() {
    return {
      topicInfo: {},
    };
  },
  watch: {
    questionInfo: {
      handler(val) {
        if (val) {
          this.topicInfo = this.$Tools.copyObj(this.questionInfo);
          // 判断是否回答过
          if (this.topicInfo.courseExamRecordId) {
            // this.topicInfo.doAnswer = this.topicInfo.questionContext.doAnswer;
            // if (this.topicInfo.questionContext?.subQuestions) {
            //     this.topicInfo.questionContext.subQuestions.map((item, index) => {
            //         return {
            //             ...item,
            //             questionId: index + 1,  // 自定义题目id
            //             doAnswer: "",  // 自定义用户答案字段
            //             questionScore: 0,  // 自定义用户得分
            //             isCorrect: 2,  // 自定义答案是否正确，1：正确，2：错误
            //         }
            //     })
            // }
          } else {
            if (this.topicInfo.questionContext?.subQuestions) {
              // this.topicInfo.questionContext.subQuestions.forEach((item, index) => {
              //     item.questionId = index + 1;
              //     item.doAnswer = "";
              //     item.questionScore = 0;
              //     item.isCorrect = 2;
              //     // console.log(index+1)
              //     // return {
              //     //     ...item,
              //     //     questionId: index + 1,  // 自定义题目id
              //     //     doAnswer: "",  // 自定义用户答案字段
              //     //     questionScore: 0,  // 自定义用户得分
              //     //     isCorrect: 2,  // 自定义答案是否正确，1：正确，2：错误
              //     // }
              // })
            }
          }
        }
      },
      deep: true,
      immediate: true,
    },
  },

  mounted() {
    this.setRecordTimeInterval();
  },
  beforeUnmount() {
    if (this.recordTimeInterval) {
      clearInterval(this.recordTimeInterval);
      this.recordTimeInterval = null;
    }
  },

  methods: {
    getAnswer(info, type) {
      let result = "";
      let answer = info.answer;
      if (type == "doAnswer") {
        answer = info.doAnswer;
      }
      // 单选题答案
      if (info.type == 1 || info.type == 9) {
        result = this.getChoiceLabel(answer, info.options);
      } else if (info.type == 2) {
        // 多选
        result = this.getMuitipleChoiceLabel(answer, info.options);
      } else if (info.type == 4 || info.type == 11) {
        // 判断
        if (answer == "") {
          return "";
        }
        result = answer == "true" ? "对" : "错";
      } else if (info.type == 3 || info.type == 14) {
        // 填空
        result = this.getFillLabel(info.options, type);
      } else if (info.type == 6 || info.type == 15) {
        // 排序
        result = answer;
      } else if (info.type == 7 || info.type == 16 || info.type == 13 || info.type == 17) {
        // 排序
        result = answer;
      }
      return result;
    },
    // 单选题答案转换
    getChoiceLabel(value, options) {
      let label = "";
      options.forEach((item) => {
        if (item.serial == value) {
          label = item.label;
        }
      });
      return label;
    },
    // 多选题答案转换
    getMuitipleChoiceLabel(value, options) {
      if (!options) return;
      // 多选多个答案拼接
      if (typeof value == "string") {
        value = value.split(",");
      }
      let label = "";
      options.forEach((item) => {
        value.forEach((sitem) => {
          if (item.serial == sitem) {
            label += item.label;
          }
        });
      });
      return label;
    },
    // 填空题答案转换
    getFillLabel(options, type) {
      if (!options) return;
      let label = "";
      options.forEach((item, index) => {
        label += `填空${index + 1}：${type == 'doAnswer' ? item.doAnswer : item.content}、`
      });
      return label.slice(0, -1);
    },
    setRecordTimeInterval() {
      if (!this.$Tools.empty(this.testExamInfo.otherRule)) {
        this.recordTimeInterval = setInterval(() => {
          if (this.topicInfo.answerSection == null) {
            this.topicInfo.answerSection = 1;
          } else {
            this.topicInfo.answerSection++;
          }
          // 按每题作答时间提交
          if (this.testExamInfo.otherRule.timeType == 2) {
            this.$emit("answerQuestion", this.topicInfo);
            // 当作答时间超过设定时间，该题设置为已完成并且不给作答
            if (
              this.topicInfo.answerSection >= this.testExamInfo.otherRule.perQuestionTime
            ) {
              this.topicInfo.questionContext.isFinish = true;
              this.$emit("answerQuestion", this.topicInfo);
              setTimeout(() => {
                this.$emit("showAnalysis", true);
              }, 1000);
              if (this.recordTimeInterval) {
                clearInterval(this.recordTimeInterval);
                this.recordTimeInterval = null;
              }
            }
          }
          // 判断当提交后定时器关闭
          else if (this.isShowScoring || this.topicInfo.showAnalysis) {
            if (this.recordTimeInterval) {
              clearInterval(this.recordTimeInterval);
              this.recordTimeInterval = null;
            }
          }
        }, 1000);
      }
    },
    getIsShow(showId) {
      let flag = false;
      if (!this.$Tools.empty(this.testExamInfo.otherRule)) {
        if (!this.$Tools.empty(this.testExamInfo.otherRule.showAnswer)) {
          if (
            this.testExamInfo.otherRule.showAnswer.findIndex((item) => item == showId) !=
            -1
          ) {
            flag = true;
          }
        }
      }
      return flag;
    },
    getAudioUrl(info) {
      let ruleInfo = this.$Tools.jsonDecode(info);
      if (!this.$Tools.empty(ruleInfo)) {
        return ruleInfo.listeningRule?.audioUrl;
      }
    },
    // 答题(刷新缓存试题便于提交)
    answerQuestion(info) {
      // 判断试题内容是否存在
      if (this.topicInfo.questionContext) {
        // 使用 map 生成新数组，直接替换原数组
        this.topicInfo.questionContext.subQuestions = this.topicInfo.questionContext.subQuestions.map(
          (item) => {
            if (item.questionId == info.questionId) {
              return this.$Tools.copyObj(info); // 替换匹配项
            }
            return item; // 保留其他项
          }
        );
        // this.topicInfo.questionContext.isFinish = !this.$Tools.empty(this.topicInfo.questionContext.doAnswer);   // 是否已完成
        // 遍历子题看是否有存答案
        this.topicInfo.questionContext.subQuestions.forEach((item) => {
          if (!this.$Tools.empty(item.doAnswer)) {
            this.topicInfo.questionContext.isFinish = true;
          }
        });
        this.$emit("answerQuestion", this.topicInfo);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.my-20 {
  margin: 20px 0;
}

.topic_select {
  .topic_type {
    // margin-top: 1rem;
    min-width: 45px;
    padding: 0 8px;
    height: 21px;
    background: rgba(0, 199, 88, 0.2);
    border-radius: 4px;
    border: 1px solid #00c758;
    line-height: 21px;
    text-align: center;
    font-size: 12px;
    color: #00c758;
  }

  .topic_content {
    // overflow-x: auto;

    .topic_title {
      font-size: 16px;
      color: #242324;
      font-weight: 600;
    }
  }
}

.bottom_box {
  position: absolute;
  left: calc(50% - 60px);
  bottom: 40px;
  text-align: center;

  .btn_view {
    width: 120px;
    height: 42px;
    background: linear-gradient(90deg, #00d5c2, #00d498);
    border-radius: 21px;
    text-align: center;
    line-height: 42px;
    color: #fff;
    font-size: 18px;
  }

  .view_analysis {
    color: #13d6aa;
  }
}

.topic_answer {
  width: 100%;
  // height: 222px;
  // background: rgba(19, 214, 170, 0.05);
  border-radius: 10px;
  // padding: 20px;
  color: #666666;
  box-sizing: border-box;

  .answer_top {
    background: #F8F9FA;
    border-radius: 8px;
    width: 100%;
    box-sizing: border-box;

    .user_answer {
      position: relative;

      .bg_line {
        width: 73px;
        height: 8px;
        background: rgba(19, 214, 170, 0.2);
        position: absolute;
        bottom: 6px;
        left: 0;
      }
    }

    .error_value_answer {
      color: RGBA(255, 49, 49, 1);
    }

    .correct_value_answer {
      color: RGBA(0, 199, 88, 1);
    }

    .btn_ask {
      width: 64px;
      height: 28px;
      background: linear-gradient(90deg, #00d5c2, #00d498);
      border-radius: 14px;
      line-height: 28px;
      text-align: center;
      color: #fff;
    }

    .get_score {
      color: #fd673b;
    }
  }

  .question_analyze {
    color: #333333;
    font-weight: 600;
  }
}

.marker_info {
  width: 100%;
  background: rgba(19, 214, 170, 0.05);
  border-radius: 10px;
  padding: 20px;
  box-sizing: border-box;

  .marker_label {
    font-size: 14px;
    color: #999999;
  }
}
</style>
